import React, { useState, useEffect } from "react";
import "./campusDetails.css";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { Button, ButtonGroup } from "@vds/buttons";
import { Input, TextArea } from "@vds/inputs";
import { DropdownSelect } from "@vds/selects";
import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { RadioButtonGroup } from "@vds/radio-buttons";
import { Title } from "@vds/typography";
import { GetCity, GetState, GetCountries } from "react-country-state-city";
import { handleSiteDelete } from "../../Sites/SiteService";
import {
  removeSiteFromCampus,
  editSiteTag,
  editCampusTags,
} from "../../../global/utility/Utils";
import { useSelector, useDispatch } from "react-redux";
import SearchInput from "../../../global/utility/Utils";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemSubtitle,
  ListGroupItemTitle,
} from "@vds/lists";
import { useNavigate } from "react-router-dom";
import { createFormTag } from "../../../model/reportService";
import {
  createNewandGetTagEndPoint,
  deleteTagEndPoint,
} from "../../../configuration";
import { hasPermission } from "../../../global/utility/permissionUtils";
import axiosInstance from "../../../global/axiosInterceptor";
import {
  addNewCity,
  addNewState,
  showNotificationBanner,
} from "../../../store/actions";
import { getTagAncestry } from "../../../global/utility/Utils";
import { getRandomUUID } from "../../../Token";
import { updateBuilding } from "../../../store/actions";
import { Loader } from "@vds/loaders";
import {
  fetchCountryIdsRequest,
  updateCampusDetails,
  updateCampusDetailsRequest,
} from "../../../store/actions";
import { getCityAndState, checkingStateAndCityExits, generatePayloadForMissingTags, createNewCityTag, validateNameField, trimNameField} from "../sitesUtil";
import { ROUTES } from "../../../global/constants/routesConstants";
import { NAMING_VALIDATION_ERROR } from "../../../global/constants/errorConstants";
import { COUNTRY_SRC } from "../../../global/constants/constants";
import { SITES_CHANGED_FIELD_LABELS, SITES_NOTIFICATION_TYPES } from "../../../global/constants/sitesConstants";

const CampusDetails = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get('siteId');
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    states,
    city,
    description: campusDescription,
    isCampus,
    buildings: sites,
    campusId,
    children,
    sitename,
    stateId,
  } = location?.state?.record || {};

  const [buildings, setBuildings] = useState([]);

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showSecondPopup, setShowSecondPopup] = useState(false);
  const [popupType, setPopupType] = useState("");

  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");

  const [selectedCountry, setSelectedCountry] = useState({});
  const [selectedState, setSelectedState] = useState({});
  const [selectedCity, setSelectedCity] = useState({});

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [filteredSites, setFilteredSites] = useState([]);
  const [originalFilteredSites, setOriginalFilteredSites] = useState([]);
  const [checkedSites, setCheckedSites] = useState([]);
  const [editButtonClick, setEditButtonClick] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [siteNameError, setSiteNameError] = useState("");
  const [originalSiteName, setOriginalSiteName] = useState("");
  const [originalState, setOriginalState] = useState(
    states || "Select a State"
  );
  const [originalCity, setOriginalCity] = useState(city || "Select a City");

  const [description, setDescription] = useState("");
  const [originalDescription, setOriginalDescription] = useState("");
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const { siteTagList } = useSelector((state) => state?.sitesReducer);
  const selectedRole = JSON.parse(sessionStorage.getItem("selectedRole"));
  const [showNotification, setShowNotification] = useState(false);
  const [showDeleteCampusModal, setShowDeleteCampusModal] = useState(false);
  const [campusDeleteLoading, setCampusDeleteLoading] = useState(false);
  const [flagUpdate, setFlagUpdate] = useState(false);

  useEffect(() => {
    if (!cid) {
      console.error('Missing siteId parameter');
      navigate('/sites');
    }
  }, [cid, navigate]);

  useEffect(() => {
    if (siteTagList && cid && !editButtonClick) {
      setSelectedCountry({
        label: "United States",
        value: 233,
      });
      const ancestry = getTagAncestry(siteTagList, cid, 3);
      let parentState = null;
      let parentCity = null;
      let parentCampus = null;

      ancestry.forEach((ancestor) => {
        if (ancestor.kind === "ts.tag.state") {
          parentState = ancestor;
        } else if (ancestor.kind === "ts.tag.city") {
          parentCity = ancestor;
        } else if (ancestor.kind === "ts.tag.campus") {
          parentCampus = ancestor;
        }
      });

      setSelectedState({
        label: parentState?.name || "Select a State",
        value: "",
      });
      setSelectedCity({
        label: parentCity?.name || "Select a City",
        value: "",
        id: parentCity?.id || "",
      });
      if (parentCampus) {
        setSiteName(parentCampus?.name || "");
        setOriginalDescription(parentCampus?.description || "");
        setDescription(parentCampus?.description || "");
      } else {
        setSiteName("");
        setOriginalDescription("");
      }
    }
  }, [siteTagList]);

  useEffect(() => {
    if (siteTagList && cid) {
      const updatedBuildings = siteTagList?.sites?.filter((site) =>
        (site?.tagids || []).includes(cid)
      );
      setBuildings(updatedBuildings);
    }
  }, [siteTagList, cid]);

  useEffect(() => {
    async function fetchStates() {
      try {
        const statesList = await GetState(selectedCountry.value,COUNTRY_SRC);
        if (statesList?.length) {
          setStateList(
            statesList.map((state) => ({ value: state.id, label: state.name }))
          );
        }
      } catch (error) {
        console.error("Failed to fetch states:", error);
      }
    }

    selectedCountry?.value && fetchStates();
  }, [selectedCountry?.value]);

  useEffect(() => {
    async function fetchCities() {
      try {
        const cities = await GetCity(
          selectedCountry.value,
          selectedState.value,
          COUNTRY_SRC
        );
        if (cities?.length) {
          setCityList(
            cities.map((city) => ({ value: city.id, label: city.name }))
          );
        }
      } catch (error) {
        console.error("Failed to fetch cities:", error);
      }
    }
    selectedCountry && selectedState && fetchCities();
  }, [selectedCountry?.value, selectedState?.value]);

  //set standalone sites useEffect
  useEffect(() => {
    if (siteTagList) {
      const parsedCampuses = siteTagList.campuses;
      const sitesObject = siteTagList.sites;

      const filteredSites = sitesObject.filter((site) => {
        return !site?.tagids?.some((tagId) =>
          parsedCampuses?.some((campus) => campus.id === tagId)
        );
      });

      setFilteredSites(filteredSites);
      setOriginalFilteredSites(filteredSites);
    }
  }, [siteTagList]);

  const handleCheckboxChange = (site, checked) => {
    setCheckedSites((prev) => {
      const newCheckedSites = checked
        ? [...prev, site]
        : prev.filter((s) => s.id !== site.id);
      return newCheckedSites;
    });
  };

  useEffect(() => {
    if (stateList.length > 0 && selectedState?.label && selectedState?.label !== "Select a State" && !selectedState?.value) {
      const stateOption = stateList?.find(
        (state) => state?.label === selectedState?.label
      );
      if (stateOption && stateOption?.value !== selectedState?.value) {
        setSelectedState(stateOption);
      }
    }
  }, [stateList, selectedState?.label]);

  // COmmented on purpose

  // useEffect(() => {
  //   if (
  //     cityList.length > 0 &&
  //     selectedCity?.label !== "Select a City" &&
  //     selectedCity?.label !== undefined
  //   ) {
  //     const cityOption = cityList?.find(
  //       (city) => city?.label === selectedCity?.label
  //     );
  //     setSelectedCity(cityOption || { label: "", value: "" });
  //   }
  // }, [cityList, selectedCity?.label]);

  const handleStateChange = (event) => {
    const selectedOption = event.target.value;
    const selectedState = stateList.find(
      (state) => state.label === selectedOption
    );
    if (selectedState) {
      setSelectedState(selectedState);
      setSelectedCity({ label: "", value: "" });
    }
  };

  const handleCityChange = (event) => {
    const selectedOption = event.target.value;
    const selectedCity = cityList.find((city) => city.label === selectedOption);
    setSelectedCity(selectedCity);
  };

  const handleAddBuilding = () => {
    if (!hasPermission("Site management", "Edit")) {
      showPermissionsBanner();
    } else {
      setShowPopup(true);
      setPopupType("add");
      setSelectedOption("radioOne");
    }
  };

  const handleRemoveBuilding = (building) => {
    setShowPopup(true);
    setPopupType("remove");
    setSelectedBuilding(building);
  };

  const handleDeleteBuilding = (building) => {
    setShowPopup(true);
    setPopupType("delete");
    setSelectedBuilding(building);
  };

  //Campus Delete Modal
  const openCampusDeleteModal = () => {
    setShowDeleteCampusModal(true);
  };
  const closeDeleteCampusModal = () => {
    setShowDeleteCampusModal(false);
  };

  //Campus Delete Banner
  const showCampusDeleteSuccessBanner = () => {
    const notificationInfo = {
      type: `Campus deleted successfully`,
      subTitle: `${siteName} has been deleted`,
      priority: "success",
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };
  //Show lack of permissions to delete site
  const showNoPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission to delete campus",
      priority: "critical",
      data: { title: "You do not have permissions!" },
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  //Delete campus
  const handleDeleteCampus = async (record) => {
    if (hasPermission("Site management", "Delete")) {
      const campusId = cid;
      if (!cid) {
        console.error("CampusID is empty!");
        return;
      }

      //grab sites of the campus to be deleted
      const ids = record?.children?.map((child) => child?.siteTagId);

      //capture parent id
      const ancestry = getTagAncestry(siteTagList, campusId, 3);
      const parentId = ancestry[1].id;

      const findTagIds = (id) => {
        const city = siteTagList?.cities.find((city) => city.id === id);
        return city ? city.tagids : [];
      };
      const tagIds = findTagIds(parentId); //find tagIds to attach sites of the deleted campus
      const tagId = tagIds[0];

      try {
        const payload = {
          accountname: activeSession?.accountId,
          filter: null,
          resourceidentifier: {
            id: cid,
          },
        };
        const response = await axiosInstance.delete(
          deleteTagEndPoint(),
          payload
        );
        if (response?.ok) {
          console.log("Campus deleted successfully");
          const promises = ids?.map((id) => {
            return removeSiteFromCampus(id, tagId, activeSession);
          });
          try {
            const results = await Promise.all(promises);
            console.log(
              "Site/s successfully attached to its parent city",
              results
            );
          } catch (error) {
            console.error("Error patching sites to parent", error);
          }
          navigate("/Sites");
          showCampusDeleteSuccessBanner(true);
        } else {
          throw new Error("Failed to delete campus");
        }
      } catch (error) {
        setCampusDeleteLoading(false);
        console.error("Error deleting campus:", error);
        throw error;
      }
    } else {
      closeDeleteCampusModal();
      showNoPermissionsBanner(true); // Show notification for lack of permissions
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchValue(value);
    if (value === "") {
      setFilteredSites(originalFilteredSites);
    } else {
      setFilteredSites(
        originalFilteredSites.filter((site) =>
          site.name.toLowerCase().includes(value)
        )
      );
    }
  };

  const handleConfirm = async () => {
    if (popupType === "remove" || popupType === "delete") {
      if (popupType === "delete") {
        setDeleteLoading(true);
        const response = await handleSiteDelete(
          selectedBuilding?.id,
          activeSession
        );
        if (response) {
          const updatedSites = siteTagList.sites.filter(
            (site) => site.id !== selectedBuilding?.id
          );
          dispatch(updateBuilding(updatedSites));
          setShowPopup(false);
        } else {
          setDeleteError("Failed to delete building. Please try again.");
        }
        setDeleteLoading(false);
      } else if (popupType === "remove") {
        try {
          setDeleteLoading(true);
          const response = await removeSiteFromCampus(
            selectedBuilding.id,
            selectedCity.id,
            activeSession
          );
          const updatedSiteId = response?.id;
          const updatedSites = siteTagList.sites.map((site) => {
            return site.id === updatedSiteId ? response : site;
          });
          dispatch(updateBuilding(updatedSites));
          setDeleteLoading(false);
          setShowPopup(false);
          setSelectedBuilding(null);
        } catch (error) {
          setDeleteError("Failed to remove building.");
          setDeleteLoading(false);
        }
      }
    } else if (popupType === "add") {
      if (selectedOption === "radioOne") {
        setShowPopup(false);
        setShowSecondPopup(true);
      } else if (selectedOption === "radioTwo") {
        navigate("/addsite", {
          state: {
            record: {
              stateTagName: selectedState.label,
              cityTagName: selectedCity.label,
              campusTagId: cid,
            },
            mode: "add",
            fromCampusPage: true,
          },
        });
      }
    }
    setShowPopup(false);
    setSelectedBuilding(null);
  };
  const secondModalHandler = async () => {
    try {
      let updatedSites = [...siteTagList.sites];

      await Promise.all(
        checkedSites.map(async (site) => {
          try {
            const response = await removeSiteFromCampus(
              site.id,
              cid,
              activeSession
            );
            if (response?.tagids && response.tagids.includes(cid)) {
              // Update the site in the accumulated updatedSites array.
              updatedSites = updatedSites.map((s) =>
                s.id === response.id ? response : s
              );
            }
          } catch (error) {
            console.error(`Error processing site with ID ${site.id}:`, error);
          }
        })
      );
      dispatch(updateBuilding(updatedSites));
      setCheckedSites([]);
      setShowSecondPopup(false);
    } catch (error) {
      console.error("Unexpected error in secondModalHandler:", error);
    }
  };

  const handleCancel = () => {
    setShowPopup(false);
    setShowSecondPopup(false);
    setSelectedBuilding(null);
  };

  const handleModalOpenedChange = (isOpen) => {
    setShowPopup(isOpen);
  };

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleSiteNameChange = (e) => {
    const rawValue = e.target.value;
    setSiteName(rawValue);
    
    if (rawValue && !validateNameField(rawValue)) {
      setSiteNameError(NAMING_VALIDATION_ERROR);
    } else {
      setSiteNameError("");
    }
  };

  const editClickHandler = () => {
    if (!hasPermission("Site management", "Edit")) {
      showPermissionsBanner();
    } else {
      if (editButtonClick) {
        if (siteNameError) {
          return;
        }
        handleSaveClick();
      }
      setEditButtonClick(!editButtonClick);
    }
  };

  const handleSaveClick = async () => {
    try {
      let updatedSiteTagList = { ...siteTagList };
      let finalPayload = {};
      let newCityCreated = null;
      let newStateCreated = null;

      const campusNameChanged = siteName !== originalSiteName;
      const campusDescriptionChanged = description !== originalDescription;
      const campusLocationChanged =
        selectedState.label !== originalState ||
        selectedCity.label !== originalCity;

      if (campusNameChanged || campusDescriptionChanged) {
        finalPayload.name = trimNameField(siteName);
        finalPayload.description = description;
      }

      if (campusLocationChanged) {
        const {
          countryExists,
          stateExists,
          cityExists,
          countryId,
          stateId,
          cityId,
        } = checkingStateAndCityExits(
          siteTagList,
          selectedState.label,
          selectedCity.label,
          selectedCountry.label
        );

        if (stateExists && cityExists) {
          finalPayload.tagids = [cityId];
        } else if (stateExists && !cityExists) {
          try {
            const payloadForNewCity = {
              accountname: activeSession.accountId,
              tags: [
                {
                  kind: "ts.tag.city",
                  name: selectedCity.label,
                  tagids: [stateId],
                  nestedtags: [],
                },
              ],
            };

            const response = await createNewCityTag(payloadForNewCity);
            if (response && response.length > 0) {
              const newCity = response[0];
              console.log("newCity", newCity);
              newCityCreated = newCity;
              finalPayload.tagids = [newCity?.id];
            } else {
              console.error("Failed to create new city tag");
            }
          } catch (error) {
            console.error("Error creating new city tag:", error);
          }
        } else {
          const payloadForMissing = generatePayloadForMissingTags(
            activeSession,
            selectedState.label,
            selectedCity.label,
            countryId
          );
          try {
            const response = await createFormTag(payloadForMissing);
            if (response && response.length > 0) {
              const newState = response[0];
              if (
                newState &&
                newState.nestedtags &&
                newState.nestedtags.length > 0
              ) {
                const newCity = newState.nestedtags[0];
                newCityCreated = newCity;
                newStateCreated = newState;
                setOriginalState(newState.name);
                setOriginalCity(newCity.name);
                finalPayload.tagids = [newCity.id];
              } else {
                console.error("Failed to retrieve new city tag from response");
              }
            } else {
              console.error(
                "Failed to create tags or retrieve new tags from response",
                response
              );
            }
          } catch (error) {
            console.error("Error creating tags:", error);
          }
        }
      }

      if (Object.keys(finalPayload).length > 0) {
        const result = await new Promise((resolve, reject) => {
          dispatch(
            updateCampusDetailsRequest({
              cid,
              finalPayload,
              activeSession,
              currentSiteTagList: siteTagList,
              resolve,
              reject,
            })
          );
        });

        setOriginalSiteName(result.name);
        setOriginalDescription(result.description);
        setDescription(result.description);
        updatedSiteTagList.campuses = updatedSiteTagList.campuses.map(
          (campus) =>
            campus?.id === cid && campus?.kind === "ts.tag.campus"
              ? {
                  ...campus,
                  id: result.id,
                  name: result.name,
                  description: result.description,
                  tagids: [result.tagids[0]],
                  kind: result.kind,
                }
              : campus
        );
      }

      if (newCityCreated) {
        updatedSiteTagList.cities = updatedSiteTagList.cities
          ? [...updatedSiteTagList.cities, newCityCreated]
          : [newCityCreated];
      }
      if (newStateCreated) {
        updatedSiteTagList.states = updatedSiteTagList.states
          ? [...updatedSiteTagList.states, newStateCreated]
          : [newStateCreated];
      }

      dispatch(updateCampusDetails(updatedSiteTagList));
      dispatch(fetchCountryIdsRequest(undefined, true));

      if (Object.keys(finalPayload).length > 0) {
        showCampusUpdatedSuccessBanner(campusNameChanged, campusDescriptionChanged, campusLocationChanged);
      }
    } catch (error) {
      console.error("Error in handleSaveClick:", error);
    }
  };

  //Campus Update Banner
  const showCampusUpdatedSuccessBanner = (nameChanged, descriptionChanged, locationChanged) => {
    const changedFields = [
      nameChanged && SITES_CHANGED_FIELD_LABELS.SITE_NAME,
      descriptionChanged && SITES_CHANGED_FIELD_LABELS.SITE_DESCRIPTION,
      locationChanged && SITES_CHANGED_FIELD_LABELS.SITE_LOCATION
    ].filter(Boolean);
    const notificationInfo = {
      type: SITES_NOTIFICATION_TYPES.CAMPUS_UPDATE_SUCCESS,
      subTitle: changedFields.length > 0
        ? `${siteName}'s ${changedFields.join(", ")} ${changedFields.length > 1 ? 'have' : 'has'} been updated`
        : `${siteName} has been updated`,
      priority: "success",
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const makeRecord = (building) => ({
    stateTagName: selectedState?.label,
    cityTagName: selectedCity?.label,
    stateTagId: originalState,
    cityTagId: originalCity,
    siteTagId: building?.id,
    siteTagName: building?.name,
    campusTagId: cid,
    description: building?.description,
  });

  return (
    <div className="campus-details-container">
      {showPopup && (
        <Modal opened={showPopup} onOpenedChange={handleModalOpenedChange}>
          <ModalTitle>
            <Title size="large" bold>
              {popupType === "remove"
                ? "Remove building from campus"
                : popupType === "delete"
                ? "Delete building"
                : "Add building"}
            </Title>
          </ModalTitle>
          <ModalBody>
            {popupType === "remove" ? (
              "Are you sure you’d like to remove this building from the campus? Selecting “yes” will make this building a unique site within your organization."
            ) : popupType === "delete" ? (
              <>
                Are you sure you’d like to delete this building? Selecting “yes”
                will remove this building completely from your organization.
                {deleteLoading && (
                  <Loader
                    active={true}
                    fullscreen={false}
                    surface="light"
                  ></Loader>
                )}
                {deleteError && <p>{deleteError}</p>}
              </>
            ) : (
              <>
                <div className="AddBuilding-modal-gap">
                  What would you like to do?
                </div>
                <RadioButtonGroup
                  data-testid="campusDetails_addingSiteToCampusRadioButtonGroup"
                  onChange={handleRadioChange}
                  error={false}
                  value={selectedOption}
                  data={[
                    {
                      name: "group",
                      children: "Add existing building to campus",
                      value: "radioOne",
                      ariaLabel: "radio one",
                      disabled: false,
                    },
                    {
                      name: "group",
                      children: "Add new building to campus",
                      value: "radioTwo",
                      ariaLabel: "radio two",
                      disabled: false,
                    },
                  ]}
                />
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <ButtonGroup
              childWidth={"100%"}
              viewport={"desktop"}
              rowQuantity={{ desktop: 2 }}
              data={[
                {
                  children: "No, cancel",
                  size: "medium",
                  use: "secondary",
                  "data-testid": "campusDetails_cancelButton",
                  onClick: handleCancel,
                },
                {
                  children:
                    popupType === "remove"
                      ? "Yes, remove"
                      : popupType === "delete"
                      ? "Yes, delete"
                      : "Submit",
                  size: "medium",
                  use: "primary",
                  "data-testid":
                    "campusDetails_yesRemoveDeleteSubmitConditionalButton",
                  onClick: handleConfirm,
                },
              ]}
              alignment={"left"}
            />
          </ModalFooter>
        </Modal>
      )}

      {showSecondPopup && (
        <Modal opened={showSecondPopup} onOpenedChange={setShowSecondPopup}>
          <ModalTitle>
            <Title size="large" bold>
              Add building
            </Title>
          </ModalTitle>
          <ModalBody>
            <div style={{ marginBottom: "30px" }}>
              <SearchInput
                value={searchValue}
                data-testid="campusDetails_searchSitesInput"
                onChange={handleSearchChange}
                placeholder="Search sites"
              />
            </div>
            <>
              {filteredSites.map((site, index) => {
                const { city, state } = getCityAndState(site.tagids, siteTagList);

                return (
                  <ListGroup
                    key={index}
                    topLine={false}
                    bottomLine={true}
                    surface="light"
                    viewport="mobile"
                  >
                    <ListGroupItem
                      actionElement="checkbox"
                      data-testid="campusDetails_checkboxForAddingSite"
                      onClick={(e, data) => {
                        handleCheckboxChange(
                          site,
                          !checkedSites.some(
                            (checkedSite) => checkedSite.id === site.id
                          )
                        );
                      }}
                      checkbox={{
                        checked: checkedSites.some(
                          (checkedSite) => checkedSite.id === site.id
                        ),
                        onChange: (e) =>
                          handleCheckboxChange(site, e.target.checked),
                      }}
                    >
                      <ListGroupItemTitle bold={false}>
                        {site.name}
                      </ListGroupItemTitle>
                      <ListGroupItemSubtitle>{`${city}, ${state}`}</ListGroupItemSubtitle>
                    </ListGroupItem>
                  </ListGroup>
                );
              })}
            </>
          </ModalBody>
          <ModalFooter className="modal-footer-fixed">
            <ButtonGroup
              childWidth={"100%"}
              viewport={"desktop"}
              rowQuantity={{ desktop: 2 }}
              data={[
                {
                  children: "Cancel",
                  size: "medium",
                  use: "secondary",
                  "data-testid": "campusDetails_cancelButton",
                  onClick: handleCancel,
                },
                {
                  children: "Submit",
                  size: "medium",
                  use: "primary",
                  "data-testid": "campusDetails_submitButton",
                  onClick: secondModalHandler,
                },
              ]}
              alignment={"left"}
            />
          </ModalFooter>
        </Modal>
      )}

      {showDeleteCampusModal && (
        <Modal opened={showDeleteCampusModal}>
          <ModalTitle>Delete campus</ModalTitle>
          <ModalBody>
            Deleting the campus removes the group relationship between the sites
            in this campus but will not delete the sites themselves.
          </ModalBody>
          <ModalFooter
            buttonData={{
              primary: {
                width: "100%",
                children: campusDeleteLoading ? "Loading" : "Yes, delete",
                disabled: campusDeleteLoading,
                "data-testid": "campusDetails_campusDeleteButton",
                onClick: () => handleDeleteCampus(location?.state?.record),
              },
              close: {
                width: "100%",
                children: "No, cancel",
                disabled: campusDeleteLoading,
                "data-testid": "campusDetails_campusNoDeleteButton",
                onClick: () => closeDeleteCampusModal(),
              },
            }}
          />
        </Modal>
      )}

      <div className="breadcrumbs-heading-section">
        <Breadcrumbs surface="light">
          <BreadcrumbItem>
            <Link
              data-testid="campusDetails_settingsLink"
              to="/settings"
              className="breadcrums-item_link"
            >
              Settings
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              data-testid="campusDetails_sitesLink"
              to="/Sites"
              className="breadcrums-item_link"
            >
              Sites
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>Campus Details</BreadcrumbItem>
        </Breadcrumbs>
        <div className="campus-heading">
          {siteName || "Site name loading..."}
        </div>
      </div>
      <div className="campus-details">
        <div className="info-section">
          <div className="site-info">
            <div className="site-info-header">
              <h2>Site Info</h2>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                }}
              >
                <Button
                  variant="text"
                  size="small"
                  use="secondary"
                  data-testid="campusDetails_saveOrEditConditionalButton"
                  onClick={editClickHandler}
                  disabled={editButtonClick && !!siteNameError}
                >
                  {editButtonClick ? "Save" : "Edit"}
                </Button>
                {/* <Button
                  variant="text"
                  size="small"
                  use="secondary"
                  onClick={() => openCampusDeleteModal()}
                >
                  Delete
                </Button> */}
              </div>
            </div>
            <div className={`info-field ${!editButtonClick ? "disabled" : ""}`}>
              <Input
                type="text"
                label="Site name"
                value={siteName}
                data-testid="campusDetails_siteNameInput"
                onChange={handleSiteNameChange}
                disabled={!editButtonClick}
                error={!!siteNameError}
                errorText={siteNameError || " "}
              />
            </div>
            <div className={`info-field ${!editButtonClick ? "disabled" : ""}`}>
              <DropdownSelect
                label="State"
                errorText="Select a state"
                error={false}
                inlineLabel={false}
                value={selectedState?.label}
                data-testid="campusDetails_stateSelectionDropdown"
                onChange={handleStateChange}
                options={stateList}
                disabled={!editButtonClick}
              >
                {stateList?.length > 0 &&
                  [
                    ...new Map(
                      stateList.map((item) => [item["value"], item])
                    ).values(),
                  ]?.map((item) => (
                    <option value={item?.label}>{item?.label}</option>
                  ))}
              </DropdownSelect>
            </div>
            <div className="info-field">
              <DropdownSelect
                label="City"
                errorText="Select a city"
                error={false}
                inlineLabel={false}
                value={selectedCity?.label}
                data-testid="campusDetails_citySelectionDropdown"
                onChange={handleCityChange}
                options={cityList}
                disabled={!editButtonClick}
              >
                {cityList?.length > 0 &&
                  [
                    ...new Map(
                      cityList.map((item) => [item["value"], item])
                    ).values(),
                  ]?.map((item) => (
                    <option value={item?.label}>{item?.label}</option>
                  ))}
              </DropdownSelect>
            </div>
            <div className="textarea-container">
              <TextArea
                label="Site description"
                readOnly={false}
                required={false}
                value={description}
                data-testid="campusDetails_siteDescriptionTextArea"
                onChange={(e) => setDescription(e.target.value)}
                disabled={!editButtonClick}
              />
            </div>
          </div>
          <div className="buildings">
            <div className="buildings-header">
              <h2>Buildings</h2>
              <Button
                variant="text"
                size="small"
                className="edit-button"
                use="secondary"
                data-testid="campusDetails_addBuildingButton"
                onClick={handleAddBuilding}
                classname="add-button"
              >
                Add Building
              </Button>
            </div>
            <div className="buildings-content">
              {buildings
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((building) => (
                  <div
                    key={building?.id || building?.key}
                    className="building-item"
                  >
                    <div className="building-info">
                      <span className="building-name">
                        {building?.sitename || building?.name}
                      </span>{" "}
                      <div className="building-actions">
                        <div
                          className="button-box"
                          data-testid="campusDetails_removeBuildingIcon"
                          onClick={() => handleRemoveBuilding(building)}
                        >
                          <Icon name="close-alt" size="small" />
                          <h6>Remove</h6>
                        </div>
                        {/* <div
                          className="button-box"
                          onClick={() => handleDeleteBuilding(building)}
                        >
                          <Icon name="trash" size="small" />
                          <h6>Delete</h6>
                        </div> */}
                      </div>
                    </div>
                    <Link
                      data-testid="campusDetails_editSiteLink"
                      to={ROUTES.EDIT_SITE}
                      state={{
                        record: makeRecord(building),
                        fromCampusPage: true,
                        mode: "edit",
                      }}
                      className="building-link"
                    >
                      View details
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CampusDetails;